import { Auth0Plugin, createAuth0 } from "@auth0/auth0-vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { App as Application, createApp, markRaw } from "vue";
import { Router } from "vue-router";
import App from "./App.vue";
import router from "./router";

// ======== STYLE/ICON IMPORTS
import "@/assets/all.css";
import "@/assets/css/animate_need.css";
import "@/assets/css/css.css";
import "@/assets/css/materialSymbolsOutlined.css";
import "@/assets/css/mpicons.css";
import "cropperjs/dist/cropper.css";

import i18n from "@/utils/i18n";
import registerComponents from "./plugins/inputs";
import { GetGuid } from "./utils/Utilities";

declare module "pinia" {
	export interface PiniaCustomProperties {
		router: Router;
		auth0: Auth0Plugin;
	}
}

async function bootstrap() {
	const config = await (await fetch("/config.json")).json();

	const app: Application = createApp(App);

	registerComponents(app);

	const pinia = createPinia();
	const auth0 = createAuth0({
		domain: config.auth0.domain,
		audience: config.auth0.audience,
		client_id: config.auth0.clientId,
		redirect_uri: window.location.origin + "?auth0=true"
	});

	pinia.use(({ store }): any => {
		store.router = markRaw(router);
		store.auth0 = markRaw(auth0);
	});
	pinia.use(piniaPluginPersistedstate as any);

	app.config.globalProperties.$uuid4 = () => GetGuid().toString();
	app.use(i18n);
	app.use(pinia).use(auth0).use(router).mount("#app");
}

bootstrap();
